import { render, staticRenderFns } from "./Wuliu.vue?vue&type=template&id=7a2cd540&scoped=true"
import script from "./Wuliu.vue?vue&type=script&lang=js"
export * from "./Wuliu.vue?vue&type=script&lang=js"
import style0 from "./Wuliu.vue?vue&type=style&index=0&id=7a2cd540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2cd540",
  null
  
)

export default component.exports